/* Dados estáticos da landing — sem JSX, sem cálculo. */

export const INTEGRACOES_HERO: ReadonlyArray<{ glyph: string; rotulo: string }> = [
  { glyph: "nuvemshop", rotulo: "Nuvemshop" },
  { glyph: "meta", rotulo: "Meta Ads" },
  { glyph: "ga", rotulo: "Google Analytics" },
  { glyph: "gads", rotulo: "Google Ads" },
];

/* Estacionadas — exibidas como "Em breve" no hero. Permitido na landing de
   pré-lançamento por decisions.md §31 (o "Em breve" vale na waitlist/landing,
   nunca no app do lojista). */
export const INTEGRACOES_EM_BREVE: ReadonlyArray<{ glyph: string; rotulo: string }> = [
  { glyph: "olist", rotulo: "Olist ERP" },
  { glyph: "mercadolivre", rotulo: "Mercado Livre" },
];

/* DEPOIMENTO — real e autorizado. Matheus é sócio do projeto e usa o Lucraa em
   fase beta; a fala reflete o uso real do produto. NÃO é placeholder — não trocar
   por mock nem remover sem aprovação. */
export const DEPOIMENTO = {
  texto:
    "Eu olhava o ROAS no gerenciador e achava que estava tudo certo. O Lucraa mostrou que uma campanha minha estava R$ 6.400 no vermelho todo mês — descontando CMV, frete e imposto. Pausei na hora. Hoje sei o lucro real de cada produto, não só a venda.",
  autor: "Matheus",
  loja: "Koloni Skate Shop",
};

/* Nota do fundador — história real e aprovada: consultoria → identificamos o problema →
   construímos o Lucraa pra mostrar se a campanha dá lucro, não só se performa bem. */
export const FUNDADOR = {
  texto:
    "Construímos o Lucraa porque vivíamos o problema: faturamento subindo, mas o caixa não acompanhava. Passávamos domingos na planilha pra entender pra onde o dinheiro ia — e mesmo assim o ROAS bonito do gerenciador escondia campanha no prejuízo. Fizemos a ferramenta que a gente queria ter.",
  assinatura: "Time fundador · Digitalizee",
};

/* Segurança e privacidade — espelha a postura de dados do FAQ, zero promessa de feature. */
export const SEGURANCA: ReadonlyArray<{ icone: string; titulo: string; desc: string }> = [
  {
    icone: "link",
    titulo: "APIs oficiais",
    desc: "Autorização oficial da Nuvemshop, do Google e da Meta. Nada de pedir a senha da sua loja.",
  },
  {
    icone: "eye",
    titulo: "Somente leitura",
    desc: "O Lucraa lê vendas, tráfego e anúncios. Não altera produto, preço, campanha nem pedido.",
  },
  {
    icone: "shield",
    titulo: "LGPD",
    desc: "Dados tratados conforme a lei, usados só para calcular o seu lucro — e excluídos se você desconectar.",
  },
  {
    icone: "bolt",
    titulo: "Revogue quando quiser",
    desc: "A conexão se desfaz em um clique, na sua conta ou direto na plataforma que autorizou.",
  },
];

export const FAQ: ReadonlyArray<{ pergunta: string; resposta: string }> = [
  {
    pergunta: "Já uso um dashboard de performance. Por que o Lucraa?",
    resposta:
      "Dashboards de performance medem receita atribuída — param no ROAS. O Lucraa parte do ROAS e desconta custo do produto (CMV), frete e imposto: você vê o ROAS real e o lucro de cada campanha, e o ROAS de equilíbrio por produto que diz qual aguenta escalar. Seu ROAS continua aqui — agora ele termina no lucro.",
  },
  {
    pergunta: "Então o ROAS de vocês é o certo e o da Meta é o errado?",
    resposta:
      "Não — os dois estão certos, usam janelas diferentes. A Meta conta view-through e multi-touch (janela maior); o Lucraa conta cada pedido pago uma vez, pelo último clique (mais conservador), e desconta seus custos para mostrar o lucro. Mostramos os dois lado a lado e você audita pedido a pedido — dá pra ver exatamente por que cada venda contou para um canal.",
  },
  {
    pergunta: "De onde vem o “lucro das vendas”?",
    resposta:
      "Em dois passos: receita menos os custos variáveis (CMV, frete e imposto) é a margem de contribuição; menos a mídia, é o lucro das vendas. Os custos por SKU sincronizam direto da plataforma ou você ajusta na mão — e o ajuste manual sempre vence. Enquanto um SKU não tem custo, a margem aparece como estimada, sempre sinalizada.",
  },
  {
    pergunta: "Vocês calculam margem de contribuição e ROAS de equilíbrio?",
    resposta:
      "Sim. A margem de contribuição — receita menos CMV, frete e imposto — aparece por loja, canal e produto, e dela sai o ROAS de equilíbrio: o ROAS mínimo para a campanha parar de consumir caixa. Acima dele, vale escalar; abaixo, o anúncio queima margem mesmo vendendo.",
  },
  {
    pergunta: "Quanto tempo leva para começar a ver resultado?",
    resposta:
      "As conexões levam menos de 2 minutos e os primeiros relatórios saem no mesmo dia. A primeira recomendação do dia aparece no painel na manhã seguinte.",
  },
  {
    pergunta: "Como o Lucraa acessa os dados da minha loja?",
    resposta:
      "Pelas APIs oficiais da Nuvemshop, da Meta e do Google, em modo somente leitura. O Lucraa não altera nada na sua loja — só lê vendas, tráfego e anúncios.",
  },
  {
    pergunta: "Funciona com outras plataformas além da Nuvemshop?",
    resposta:
      "Hoje o Lucraa conecta lojas Nuvemshop e mede a mídia no Meta Ads, no Google Ads e no Google Analytics — é nesse cenário que ele entrega o lucro das vendas de ponta a ponta. Mercado Livre e Olist ERP estão no roadmap (em breve).",
  },
  {
    pergunta: "Quanto custa o Lucraa?",
    resposta:
      "É um plano único com tudo incluso, a partir de R$ 197/mês — o preço acompanha o faturamento da sua loja, pela média dos últimos 90 dias. A faixa é reavaliada só na renovação: se a loja encolher, o preço desce sozinho; se crescer, a mudança só vale com crescimento sustentado. Toda faixa inclui os mesmos acessos para você e sua equipe; assento adicional tem preço fixo. Você vê a tabela completa de faixas no seu primeiro acesso. Sem “fale com vendas”.",
  },
  {
    pergunta: "Preciso de cartão para testar? E para cancelar?",
    resposta:
      "Não precisa de cartão: o teste de 7 dias é completo e você só decide se assina no fim. E cancelar é em dois cliques, na própria conta — sem fidelidade e sem multa.",
  },
];
